import * as React from "react";

export function useCreateBoardDialog() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = React.useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = React.useCallback(() => {
    setOpen(false);
  }, []);

  return {
    open,
    handleClickOpen,
    handleClose,
  };
}
